import { Component, inject } from '@angular/core';
import { Storage, ref, uploadBytesResumable } from '@angular/fire/storage';

@Component({
  selector: 'app-documents',
  imports: [],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent {

  // private readonly storage: Storage = inject(Storage);

  constructor(private storage: Storage) {
  }

  uploadFile(input: HTMLInputElement) {
    if (!input.files) return

    const files: FileList = input.files;

    for (let i = 0; i < files.length; i++) {
      try {
        const file = files.item(i);
        if (file) {
          const storageRef = ref(this.storage, file.name);
          uploadBytesResumable(storageRef, file);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }
  }

}
